import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { Observable, of } from 'rxjs';
import { PageBaseComponent } from '../../abstracts/page-base/page-base.component';
import { Team } from '../../models/team';
import { ApiService } from '../../services/api.service';
import { Parameters } from '../../utilities/parameters';

@Component({
  selector: 'app-teams',
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    ProgressSpinnerModule,
    InputTextModule,
    ButtonModule,
    TableModule,
    DialogModule,
    SelectModule,
    TabsModule,
    TextareaModule,
    ToggleSwitchModule
  ],
  providers: [MessageService],
  templateUrl: './teams.component.html',
  styles: ``
})
export class TeamsComponent extends PageBaseComponent<Team> {

  teams: Team[] = [];

  organizationOptions: { id: number; value: string }[] = [];
  selectedOrganization: { id: number; value: string } = { id: 0, value: '' };

  constructor(apiService: ApiService, messageService: MessageService) {
    super(apiService, messageService)
  }

  override onCloseDialog(): void {
    this.showDialog = false;
  }

  onOrganizationSelected(event: any): void {
    this.selectedItem.organizationId = this.selectedOrganization.id;
  }

  override onSave(): void {
    if (this.isNew) {
      this.selectedItem.organizationId = this.selectedOrganization.id;
      this.apiService.addTeam(this.selectedItem).subscribe({
        next: () => {
          this.showDialog = false;
          this.showSuccess("La squadra è stata salvata correttamente");
          this.resetItems();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err);
        },
        complete: () => {
          this.loadData();
        }
      });
    } else {
      this.apiService.updateTeam(this.selectedItem).subscribe({
        next: () => {
          this.showDialog = false;
          this.showSuccess("La squadra è stata aggiornata correttamente");
          this.resetItems();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err);
        },
        complete: () => {
          this.loadData();
        }
      });
    }
  }

  protected override loadData(): void {
    this.loading = true;

    this.apiService.getTeams().subscribe({
      next: (data) => {
        this.teams = data;
        this.dtTrigger.next(true);
      },
      error: (err: HttpErrorResponse) => {
        this.loading = false;
        this.showError(err);
      },
      complete: () => {
        this.loading = false;
      }
    })

    if ({ ...Parameters.loggedUser }.role == 1) {
      // superAdmin deve poter vedere tutte le organizzazioni
      this.apiService.getOrganizations().subscribe({
        next: (data) => {
          this.organizationOptions = data.map(org => ({
            id: org.organizationId,
            value: org.name
          })); this.dtTrigger.next(true);
        },
        error: (err: HttpErrorResponse) => {
          this.loading = false;
          this.showError(err);
        },
        complete: () => {
          this.loading = false;
        }
      })
    }
    else {
      if ({ ...Parameters.loggedUser }.role == 2) {
        this.organizationOptions = { ...Parameters.loggedUser }.organizations.map(org => ({
          id: org.organizationId,
          value: org.name
        }));

      }
    }
  }

  protected override loadSelectedInfo(): Observable<boolean> {
    this.isNew = this.selectedItem.teamId === 0;

    if (!this.isNew) {
      const found = this.organizationOptions.find(org => org.id === this.selectedItem.organizationId);
      if (found)
        this.selectedOrganization = found;
    }

    return of(true);
  }

  protected override resetItems(): void {
    this.newItem = {
      organizationId: 0,
      teamId: 0,
      name: '',
      description: '',
      isActive: false,
      organization: '',
      updatedAt: new Date()
    };

    this.selectedItem = {
      organizationId: 0,
      teamId: 0,
      name: '',
      description: '',
      isActive: false,
      organization: '',
      updatedAt: new Date()
    };

    this.selectedOrganization = { id: 0, value: '' };
  }
}
